import React from 'react';
import { Pane } from '@leverege/ui-elements';
import TwoFactorMethodsList from "./TwoFactorMethodsList.js";
export default function TwoFactorMethodsPane({
  profile,
  getMethodsFor,
  onToggleMethod,
  onViewCodes,
  project2FASettings
}) {
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "twoStepMethodsCard|card"
  }, /*#__PURE__*/React.createElement(TwoFactorMethodsList, {
    user: profile,
    methods: getMethodsFor(project2FASettings),
    onToggleMethod: onToggleMethod,
    onViewCodes: onViewCodes,
    required: project2FASettings?.required
  }));
}